import Banner from '../components/landing-page-banner/banner';
import Footer from '../components/footer';

function LandingPage() {
  return (
    <>
      <Banner />
      <Footer />
    </>
  );
}

export default LandingPage;
